export default "__VITE_ASSET__Ca$nasLJ__"